module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-day"
  }, [_c('CalendarHead', {
    staticClass: "calendar-day__head"
  }, [_vm._v(_vm._s(_vm.day))]), _c('CalendarDetail', {
    staticClass: "calendar-day__card",
    attrs: {
      "value": _vm.value,
      "count": _vm.count,
      "nothing-text": _vm.nothingText,
      "plural": _vm.plural,
      "completed": _vm.completed
    }
  }, [_vm._t("default")], 2), (_vm.prev) ? _c('router-link', {
    staticClass: "calendar-day__prev",
    attrs: {
      "to": _vm.prev
    }
  }) : _vm._e(), (_vm.next) ? _c('router-link', {
    staticClass: "calendar-day__next",
    attrs: {
      "to": _vm.next
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ffa14a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/day/component.vue
// module id = 1693683bdf57eb222c45
// module chunks = 13